import * as type from '../../../actions/index.types'

const initialState = {
    // Login-history attendance report (admin grid over /login-history/attendance)
    records: [],
    pagination: null,
    loading: false,
    error: null,

    // Punch screen — GET /api/attendance/me/status
    myStatusData: null,
    myStatusLoading: false,
    // { message, code } — code is NOT_AN_EMPLOYEE / ATTENDANCE_DISABLED / …
    myStatusError: null,

    // POST /api/attendance/punch
    punchLoading: false,
    // Last successful punch response: { punch, attendance, geofence, duplicate, … }
    lastPunchData: null,

    // GET /api/attendance/me
    myPunches: [],
    myPunchesPagination: null,
    myPunchesLoading: false,

    // GET /api/attendance/me/summary
    mySummaryDays: [],
    mySummaryTotals: null,
    mySummaryPagination: null,
    mySummaryLoading: false,

    // GET /api/attendance/enums
    attendanceEnums: null,

    // PATCH /api/attendance/:id (admin punch correction)
    updatePunchLoading: false,

    // Admin attendance management
    adminDailyRows: [],
    adminDailyPagination: null,
    adminDailyLoading: false,
    adminSummaryData: null,
    adminSummaryLoading: false,
    adminPunches: [],
    adminPunchesPagination: null,
    adminPunchesLoading: false,
    manualPunchLoading: false,
    // Shared by approve + reject — the queue disables both buttons while one decision is in flight
    punchDecisionLoading: false,
}

export function AttendanceReducer(state = initialState, action) {
    switch (action.type) {
        case type.SOCIETY_GET_ATTENDANCE_REPORT:
            return {
                ...state,
                loading: true,
                error: null,
            }
        case type.SOCIETY_GET_ATTENDANCE_REPORT_SUCCESS:
            return {
                ...state,
                loading: false,
                records: action.payload?.data?.records || [],
                pagination: action.payload?.data?.pagination || null,
                error: null,
            }
        case type.SOCIETY_GET_ATTENDANCE_REPORT_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.message,
            }

        case type.SOCIETY_GET_MY_ATTENDANCE_STATUS:
            return {
                ...state,
                myStatusLoading: true,
            }
        case type.SOCIETY_GET_MY_ATTENDANCE_STATUS_SUCCESS:
            return {
                ...state,
                myStatusLoading: false,
                myStatusData: action.payload || null,
                myStatusError: null,
            }
        case type.SOCIETY_GET_MY_ATTENDANCE_STATUS_FAILURE:
            return {
                ...state,
                myStatusLoading: false,
                myStatusError: action.error || null,
            }

        case type.SOCIETY_PUNCH_ATTENDANCE:
            return {
                ...state,
                punchLoading: true,
            }
        case type.SOCIETY_PUNCH_ATTENDANCE_SUCCESS:
            return {
                ...state,
                punchLoading: false,
                lastPunchData: action.payload || null,
            }
        case type.SOCIETY_PUNCH_ATTENDANCE_FAILURE:
            return {
                ...state,
                punchLoading: false,
            }

        case type.SOCIETY_GET_MY_ATTENDANCE_PUNCHES:
            return {
                ...state,
                myPunchesLoading: true,
            }
        case type.SOCIETY_GET_MY_ATTENDANCE_PUNCHES_SUCCESS:
            return {
                ...state,
                myPunchesLoading: false,
                myPunches: action.payload?.rows || [],
                myPunchesPagination: action.payload?.pagination || null,
            }
        case type.SOCIETY_GET_MY_ATTENDANCE_PUNCHES_FAILURE:
            return {
                ...state,
                myPunchesLoading: false,
            }

        case type.SOCIETY_GET_MY_ATTENDANCE_SUMMARY:
            return {
                ...state,
                mySummaryLoading: true,
            }
        case type.SOCIETY_GET_MY_ATTENDANCE_SUMMARY_SUCCESS:
            return {
                ...state,
                mySummaryLoading: false,
                mySummaryDays: action.payload?.days || [],
                mySummaryTotals: action.payload?.totals || null,
                mySummaryPagination: action.payload?.pagination || null,
            }
        case type.SOCIETY_GET_MY_ATTENDANCE_SUMMARY_FAILURE:
            return {
                ...state,
                mySummaryLoading: false,
            }

        case type.SOCIETY_GET_ATTENDANCE_ENUMS_SUCCESS:
            return {
                ...state,
                attendanceEnums: action.payload || null,
            }

        case type.SOCIETY_UPDATE_ATTENDANCE_PUNCH:
            return {
                ...state,
                updatePunchLoading: true,
            }
        case type.SOCIETY_UPDATE_ATTENDANCE_PUNCH_SUCCESS:
        case type.SOCIETY_UPDATE_ATTENDANCE_PUNCH_FAILURE:
            return {
                ...state,
                updatePunchLoading: false,
            }

        case type.SOCIETY_GET_ADMIN_ATTENDANCE_DAILY:
            return {
                ...state,
                adminDailyLoading: true,
            }
        case type.SOCIETY_GET_ADMIN_ATTENDANCE_DAILY_SUCCESS:
            return {
                ...state,
                adminDailyLoading: false,
                adminDailyRows: action.payload?.rows || [],
                adminDailyPagination: action.payload?.pagination || null,
            }
        case type.SOCIETY_GET_ADMIN_ATTENDANCE_DAILY_FAILURE:
            return {
                ...state,
                adminDailyLoading: false,
            }

        case type.SOCIETY_GET_ADMIN_ATTENDANCE_SUMMARY:
            return {
                ...state,
                adminSummaryLoading: true,
            }
        case type.SOCIETY_GET_ADMIN_ATTENDANCE_SUMMARY_SUCCESS:
            return {
                ...state,
                adminSummaryLoading: false,
                adminSummaryData: action.payload || null,
            }
        case type.SOCIETY_GET_ADMIN_ATTENDANCE_SUMMARY_FAILURE:
            return {
                ...state,
                adminSummaryLoading: false,
            }

        case type.SOCIETY_GET_ADMIN_ATTENDANCE_PUNCHES:
            return {
                ...state,
                adminPunchesLoading: true,
            }
        case type.SOCIETY_GET_ADMIN_ATTENDANCE_PUNCHES_SUCCESS:
            return {
                ...state,
                adminPunchesLoading: false,
                adminPunches: action.payload?.rows || [],
                adminPunchesPagination: action.payload?.pagination || null,
            }
        case type.SOCIETY_GET_ADMIN_ATTENDANCE_PUNCHES_FAILURE:
            return {
                ...state,
                adminPunchesLoading: false,
            }

        case type.SOCIETY_CREATE_MANUAL_PUNCH:
            return {
                ...state,
                manualPunchLoading: true,
            }
        case type.SOCIETY_CREATE_MANUAL_PUNCH_SUCCESS:
        case type.SOCIETY_CREATE_MANUAL_PUNCH_FAILURE:
            return {
                ...state,
                manualPunchLoading: false,
            }

        case type.SOCIETY_APPROVE_ATTENDANCE_PUNCH:
        case type.SOCIETY_REJECT_ATTENDANCE_PUNCH:
            return {
                ...state,
                punchDecisionLoading: true,
            }
        case type.SOCIETY_APPROVE_ATTENDANCE_PUNCH_SUCCESS:
        case type.SOCIETY_APPROVE_ATTENDANCE_PUNCH_FAILURE:
        case type.SOCIETY_REJECT_ATTENDANCE_PUNCH_SUCCESS:
        case type.SOCIETY_REJECT_ATTENDANCE_PUNCH_FAILURE:
            return {
                ...state,
                punchDecisionLoading: false,
            }

        default:
            return state
    }
}
